module.exports = __webpack_public_path__ + "static/media/git.3e69303b.svg";